import axios from "axios";
import { getFormDataForSurcharge } from "@/helpers/referenceHolidaySurchargesFunctions";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const apiUrl = "/index.php";

const state = () => ({
    surcharges: [],
    collections: {
        positions: [],
        filials: [],
        workers: [],
    },
    isMoreDataAvailable: true,
    totalItemsCount: 0,
});

const getters = {
    getSurcharge: (state) => (surchargeId) =>
        state.surcharges.find((surcharge) => surcharge.id.toString() === surchargeId.toString()),
};

const actions = {
    async fetchFilials({ rootState, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/filial/index`, token);

        const { data } = await axios.get(url);

        const filials = data.items.map((filial) => ({ label: filial.filial_name, value: filial.id }));

        commit("setFilialsCollection", filials);
    },
    async fetchPositions({ rootState, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/directory/position`, token);

        const { data } = await axios.get(url);
        const positions = Object.entries(data).map(([positionCode, { name }]) => ({
            label: name,
            value: positionCode,
        }));

        commit("setPositionsCollection", positions);
    },
    async fetchWorkers({ rootState, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/worker/index&job_status=1&sort=name&pagination=0`, token);

        const { data } = await axios.get(url);
        const workers = data.map((worker) => ({
            label: worker.name,
            value: worker.id,
        }));

        commit("setWorkersCollection", workers);
    },
    async fetchSurcharges({ rootState, commit }, { page, status, query }) {
        const token = rootState.authToken;
        const queryParams = [`page=${page}`, `status=${status === "all" ? "" : status}`, `name=${query}`];

        const url = addAuthKey(`${apiUrl}?r=api/surcharge/index&${queryParams.join("&")}`, token);

        const { data, headers } = await axios.get(url);
        commit("setTotalItemsCount", +headers["x-pagination-total-count"]);

        if (page === 1) {
            commit("setIsMoreDataAvailableValue", true);
            commit("setSurcharges", data);
            return;
        }
        if (data.length === 0) {
            commit("setIsMoreDataAvailableValue", false);
            return;
        }

        commit("putSurcharges", data);
    },
    async fetchSurchargeById({ rootState }, surchargeId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/surcharge/view&id=${surchargeId}`, token);

        const { data } = await axios.get(url);

        return data;
    },
    async updateSurchargesSort({ rootState, state }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/surcharge/update-sort`, token);
        const data = state.surcharges.map((surcharge, surchargeIndex) => ({
            id: surcharge.id,
            sort: state.surcharges.length - surchargeIndex,
        }));

        await axios.patch(url, data);
    },
    async deleteSurcharge({ rootState, commit }, surchargeId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/surcharge/delete&id=${surchargeId}`, token);

        const { data } = await axios.get(url);
        if (data.success) {
            commit("deleteSurcharge", surchargeId);
        }
        return data;
    },
    async createSurcharge({ rootState }, surchargeData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/surcharge/create`, token);
        const formData = getFormDataForSurcharge(surchargeData);

        const { data } = await axios.post(url, formData);

        return data;
    },
    async updateSurcharge({ rootState }, surchargeData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/surcharge/update&id=${surchargeData.id}`, token);
        const formData = getFormDataForSurcharge(surchargeData);

        const { data } = await axios.post(url, formData);

        return data;
    },
};

const mutations = {
    setFilialsCollection(state, filials) {
        state.collections.filials = filials;
    },
    setPositionsCollection(state, positions) {
        state.collections.positions = positions;
    },
    setWorkersCollection(state, workers) {
        state.collections.workers = workers;
    },
    setSurcharges(state, surcharges) {
        state.surcharges = surcharges;
    },
    putSurcharges(state, surcharges) {
        state.surcharges = [...state.surcharges, ...surcharges];
    },
    deleteSurcharge(state, surchargeId) {
        const surchargeIndex = state.surcharges.findIndex((surcharge) => surcharge.id === surchargeId);
        state.surcharges.splice(surchargeIndex, 1);
    },
    setIsMoreDataAvailableValue(state, value) {
        state.isMoreDataAvailable = value;
    },
    setTotalItemsCount(state, amount) {
        state.totalItemsCount = amount;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
